import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useStudentPayments() {
    return useQuery({
        queryKey: ['student-payments'],
        queryFn: () => apiClient('/payments/me'),
        staleTime: 1000 * 60 * 5,
    });
}
//# sourceMappingURL=useStudentPayments.js.map